module.exports = __webpack_public_path__ + "static/speaking-4989fca807dab1f8d1e6dea223f90ad9.png";